import React, { Component } from 'react';
import { Trash } from 'react-bootstrap-icons';
import { Hint } from './constants.js';
import { fetchFile } from './interface.js';
class ImageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      imgURL: '',
    };
  }

  async componentDidMount() {
    let imgURL = await fetchFile(this.props.item.EntityMetaValue, 'image');
    this.setState({ imgURL: imgURL?.finalUrl });
  }
  render() {
    let url =
      this.state.imgURL?.split('/')[this.state.imgURL?.split('/').length - 1];

    if (!this.props.item || url === 'null' || url?.split('.').length === 0) {
      return;
    } else
      return this.props.item.EntityMetaValue ? (
        <a
          className="img-comp pointer"
          onMouseOver={() => this.setState({ hover: true })}
          onMouseOut={() => this.setState({ hover: false })}
        >
          <img
            src={this.state.imgURL}
            id={this.props.id}
            alt={this.props.id}
            className="preview"
            onClick={() => window.open(this.state.imgURL, '_blank')}
          />
          {!this.props.disabled ? (
            <Hint
              placement="left"
              delay={{ show: 250, hide: 400 }}
              title="Click to delete entry"
            >
              <Trash
                color="red"
                onClick={this.props.delete}
                size={18}
                className={this.state.hover ? 'showImgCncl' : 'hideImgCncl'}
              />
            </Hint>
          ) : null}
        </a>
      ) : null;
  }
}

export default ImageComponent;
